export default __webpack_public_path__ + "static/media/East Troy Lights Game.6e7c77c8.mp4";